"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    throw: verb(1),
    return: verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  result["default"] = mod;
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    default: mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = __importStar(require("react"));
var Select_1 = __importDefault(require("./Select"));
var wallets_1 = require("../../wallets");
var react_redux_1 = require("react-redux");
var wallet_1 = require("../../actions/wallet");
var utils_1 = require("ethers/utils");
var _require = require("react-toastify"),
  toast = _require.toast;
var clipboard_copy_1 = __importDefault(require("clipboard-copy"));
var mapStateToProps = function mapStateToProps(state) {
  var walletState = state.WalletReducer;
  var selectedAccountID = walletState.get("selectedAccountID");
  var accounts = walletState.get("accounts");
  return {
    accounts: accounts,
    selectedAccountID: selectedAccountID,
    selectedAccountAddress: accounts.getIn([selectedAccountID, "address"], null),
    walletTranslations: walletState.get("walletTranslations"),
    unit: walletState.get("unit"),
    decimals: walletState.get("decimals")
  };
};
var WalletSelector = function (_super) {
  __extends(WalletSelector, _super);
  function WalletSelector() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  WalletSelector.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      walletType = _a.walletType,
      decimals = _a.decimals,
      dispatch = _a.dispatch,
      selectedAccountID = _a.selectedAccountID,
      walletTranslations = _a.walletTranslations,
      selectedAccountAddress = _a.selectedAccountAddress,
      copyCallback = _a.copyCallback;
    var options = this.getOptions();
    var blankText;
    if (options.length === 0) {
      blankText = walletTranslations.noAvailableAddress;
    } else {
      blankText = '';
    }
    var text = '';
    var balance = '';
    var isLocked = '';
    walletType !== wallets_1.RainWallet.TYPE && this.getWalletAccounts(walletType).forEach(function (account, accountID) {
      var acc = account.get("address");
      var wallet = account.get("wallet");
      if (acc) {
        isLocked = account.get("isLocked");
        text = wallets_1.truncateAddress(account.get("address"));
        balance = account.get("balance").div(new utils_1.BigNumber(10).pow(decimals).toString()).toFixed(5);
        // dispatch(wallet_1.selectAccount(accountID, wallet.type()));
      }
    });

    return React.createElement(React.Fragment, null, React.createElement("div", {
      className: "RainConnect-fieldGroup w-100"
    }, selectedAccountID != null && isLocked !== '' && React.createElement("div", {
      className: selectedAccountID == null ? "RainConnect-label selectwallet" : "RainConnect-label"
    }, selectedAccountID == null ? walletTranslations.selectAddress : "Copy Address", selectedAccountID != null && React.createElement("i", {
      className: "RainConnect-copy RainConnect-fa fa fa-clipboard",
      onClick: function onClick() {
        return __awaiter(_this, void 0, void 0, function () {
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                if (!selectedAccountAddress) return [3, 2];
                return [4, clipboard_copy_1.default(selectedAccountAddress)];
              case 1:
                _a.sent();
                if (copyCallback) {
                  copyCallback(selectedAccountAddress);
                } else {
                  toast.success("Copied to clipboard!");
                }
                _a.label = 2;
              case 2:
                return [2];
            }
          });
        });
      }
    })), walletType === wallets_1.RainWallet.TYPE ? React.createElement(Select_1.default, {
      blank: blankText,
      noCaret: options.length === 0,
      disabled: options.length === 0,
      options: options,
      selected: selectedAccountID || ""
    }) : selectedAccountID != null && isLocked !== '' && React.createElement("div", {
      className: "metamaskoption RainConnect-selected"
    }, React.createElement("span", null, selectedAccountID != null && isLocked && React.createElement("i", {
      className: "RainConnect-fa fa fa-lock"
    }), selectedAccountID != null && !isLocked && React.createElement("i", {
      className: "RainConnect-fa fa fa-check"
    }), text), React.createElement("span", null, balance))));
  };
  WalletSelector.prototype.getOptions = function () {
    var _this = this;
    var _a = this.props,
      walletType = _a.walletType,
      dispatch = _a.dispatch,
      unit = _a.unit,
      decimals = _a.decimals,
      walletTranslations = _a.walletTranslations;
    var options = [];
    this.getWalletAccounts(walletType).forEach(function (account, accountID) {
      var text = account.get("address");
      var isLocked = account.get("isLocked");
      var balance = account.get("balance");
      var wallet = account.get("wallet");
      if (text) {
        options.push({
          value: accountID,
          component: React.createElement("div", {
            className: "RainConnect-address-option"
          }, React.createElement("span", null, isLocked ? React.createElement("i", {
            className: "RainConnect-fa fa fa-lock"
          }) : React.createElement("i", {
            className: "RainConnect-fa fa fa-check"
          }), wallets_1.truncateAddress(text)), React.createElement("span", null, balance.div(new utils_1.BigNumber(10).pow(decimals).toString()).toFixed(5), " ", unit)),
          onSelect: function onSelect(option) {
            dispatch(wallet_1.selectAccount(option.value, wallet.type()));
          }
        });
      }
      if (wallets_1.needConnectWalletTypes.includes(walletType)) {
        options.push({
          value: "disconnect",
          text: walletTranslations.disconnect,
          onSelect: function onSelect(option) {
            return __awaiter(_this, void 0, void 0, function () {
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    return [4, wallet.clearSession()];
                  case 1:
                    _a.sent();
                    window.location.reload();
                    return [2];
                }
              });
            });
          }
        });
      }
    });
    return options;
  };
  WalletSelector.prototype.getWalletAccounts = function (walletType) {
    var accounts = this.props.accounts;
    return accounts.filter(function (account) {
      return account.get("wallet").type() === walletType;
    });
  };
  return WalletSelector;
}(React.PureComponent);
exports.default = react_redux_1.connect(mapStateToProps)(WalletSelector);